import { DateTime, Duration } from "luxon";

/** An object representing the local time for a center at which calls will become valid. */
export class CenterDialTime {
  /** PKey identifier. */
  id?: string;
  /** The ISO DateTime of the valid time. */
  dialTime!: string;
  /** Flag indicating if this dial time is currently respected by the server. */
  isDisabled!: boolean;
}

export class EnhancedCenterDialTime extends CenterDialTime {
  /** DateTime equivalent value of `this.dialTime`. */
  dialTimeDateTime: DateTime;

  constructor(dialTime?: CenterDialTime) {
    super();
    const defaultDialTime = DateTime.now().startOf("day");
    this.id = dialTime?.id;
    this.dialTime = dialTime?.dialTime || defaultDialTime.toISO();
    this.isDisabled = dialTime?.isDisabled || false;
    this.dialTimeDateTime = dialTime?.dialTime
      ? DateTime.fromISO(dialTime.dialTime).startOf("minute")
      : defaultDialTime;
  }

  /** Comparator returning `true` if the source is less than the comparator, false otherwise. */
  static comparator(sourceTime: EnhancedCenterDialTime, compareTime: EnhancedCenterDialTime): number {
    return sourceTime.dialTimeDateTime < compareTime.dialTimeDateTime ? -1 : 1;
  }

  /** Transform the object to its base. */
  static toBase(enhancedDialTime: EnhancedCenterDialTime): CenterDialTime {
    const { id, dialTime, isDisabled } = enhancedDialTime;
    return { id, dialTime, isDisabled };
  }
}

export class CenterDialTimeMinMax {
  minimum!: string;
  maximum!: string;
}

export class EnhancedCenterDialTimeMinMax {
  minimum: DateTime;
  maximum: DateTime;

  constructor(minMax: CenterDialTimeMinMax) {
    this.minimum = DateTime.now().startOf("day").plus(Duration.fromISOTime(minMax.minimum)).startOf("minute");
    this.maximum = DateTime.now().startOf("day").plus(Duration.fromISOTime(minMax.maximum)).startOf("minute");
  }
}
